import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { grey } from '@material-ui/core/colors';
import classNames from 'classnames';

import DotStepper from './DotStepper';

const styles = (theme) => ({
	root: {
		borderTop: `1px solid ${grey[200]}`,
		background: grey[100],
		display: 'flex',
		padding: theme.spacing.unit,
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	icon: {
		fontSize: 18,
	},
	iconNext: {
		marginLeft: theme.spacing.unit
	},
	iconRight: {
		marginRight: theme.spacing.unit
	}
});

class Navigation extends Component {
	renderBackButton() {
		const { classes, backDisabled, onBack } = this.props;
		return (
			<Button onClick={onBack} disabled={backDisabled} size="large">
				<i className={classNames('fa', 'fas fa-angle-left', classes.icon, classes.iconRight)} />
				Back
			</Button>
		);
	}

	renderNextButton() {
		const { classes, nextDisabled, onNext } = this.props;
		return (
			<Button onClick={onNext} disabled={nextDisabled} size="large">
				Next
				<i className={classNames('fa', 'fas fa-angle-right', classes.icon, classes.iconNext)} />
			</Button>
		);
	}

	render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				{this.renderBackButton()}
				<DotStepper />
				{this.renderNextButton()}
			</div>
		);
	}
}

Navigation.propTypes = {
	classes: PropTypes.object.isRequired,
	onBack: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
	nextDisabled: PropTypes.bool.isRequired,
	backDisabled: PropTypes.bool.isRequired,
};

function mapStateToProps({ exercise: { currentItem, items, resultsVisible, recording }, loader: { testMode } }) {
	return {
		recording,
		backDisabled: recording || currentItem === 0,
		nextDisabled: Boolean(recording || resultsVisible || currentItem === items.length)
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Navigation);
